import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_workspace } from '@/hooks/store/use_slices';

export function WatcherWorkspacePurchaseColor() {
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    const root = document.documentElement;
    root.classList.remove('color-purchase-shared', 'color-purchase-personal');

    root.classList.add(workspace_current.is_personal ? 'color-purchase-personal' : 'color-purchase-shared');
  }, [workspace_current.is_personal]);

  return null;
}
